var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Workload',_vm._b({},'Workload',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }